import { useLocation, useParams } from 'react-router-dom';
import { Flex, PageContainer } from '@/components';

export default function PaymentPage() {
  const params = useParams();
  const location = useLocation();

  return (
    <Flex className="rtl !text-start w-full mx-auto" style={{ maxWidth: 'min(calc(1000px), 90%)' }}>
      <PageContainer title="نتیجه تراکنش">
        <Flex direction="column" className="ltr !text-end">
          <pre>Params: {JSON.stringify(params, null, 2)}</pre>
          <br /><br />
          <pre>Location: {JSON.stringify(location, null, 2)}</pre>
        </Flex>
      </PageContainer>
    </Flex>
  );
}
